// removed by extract-text-webpack-plugin
module.exports = {"root":"success-message--root--baNkbeVu"};


//////////////////
// WEBPACK FOOTER
// ./components/success-message/styles.css
// module id = ./components/success-message/styles.css
// module chunks = 0